import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Ordine} from '../../_models/Ordine';
import {OrdineGroup} from '../../_models/_Index';
import {Subscription} from 'rxjs';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {AccountOrganizzazione} from "../../_models/AccountOrganizzazione";
import {FilterItem} from '../../_models/FilterItem';
import {TipoFormControl} from '../../_helpers/TipoFormControl';
import {LocalService} from '../../_services/local.service';
import {OrdiniLocaliListComponent} from '../ordini-locali-list/ordini-locali-list.component';

@Component({
  selector: 'app-ordini-locali',
  templateUrl: './ordini-locali.component.html',
  styleUrls: ['./ordini-locali.component.scss'],
  standalone: false
})
export class OrdiniLocaliComponent implements OnInit, OnDestroy {
  @Input() flagTerminate: boolean;
  @Input() updateEnable: boolean;
  @Input() isPersonal: boolean;
  @Output() ordineSended = new EventEmitter<Ordine>();
  @Output() ordineGroupSended = new EventEmitter<OrdineGroup>();
  @ViewChild(OrdiniLocaliListComponent) listComponent?: OrdiniLocaliListComponent;
  totalCount = 0;
  viewGroup: boolean;
  sortDirection = false;
  sortKey = 'dataTermine';
  subscription: Subscription;

  // Filtri di QUESTA tab (Inviate o Terminate). Posseduti qui, dal componente padre per-tab,
  // invece che su un BehaviorSubject condiviso in LocalService: ion-tabs tiene entrambe le tab
  // vive contemporaneamente, quindi un singleton globale faceva sì che i filtri impostati in
  // una tab venissero silenziosamente applicati anche all'altra (e viceversa).
  localFilters: FilterItem[] = [
    {
      fieldName: 'NumRegistrazione', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.numRegistrazione
    },
    {
      fieldName: 'Commessa', operazione: 5, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.commessa
    },
    {
      fieldName: 'RifOrdine', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.rifOrdine
    },
    {
      fieldName: 'CodiceOrdine', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.selectOrdine, showColumn: this.localService.showColumns.value.idDocumento
    },
    {
      fieldName: 'RifOdP', operazione: 5, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.rifOdP
    },
    {
      fieldName: 'NumFase', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.numFase
    },
    {
      fieldName: 'DataRegistrazione', operazione: 8, label: 'Termine',
      value1: new Date(2000, 0, 1, 12, 0, 0).toISOString(),
      value2: new Date(2099, 11, 31, 12, 0, 0).toISOString(),
      tipoFormControl: TipoFormControl.datetime, showColumn: this.localService.showColumns.value.dataTermine
    },
    {
      fieldName: 'RisorsaId', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.selectRisorsa, showColumn: this.localService.showColumns.value.risorsa
    },
    {
      fieldName: 'LavorazioneId', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.selectLavorazione, showColumn: this.localService.showColumns.value.lavorazione
    },
    {
      fieldName: 'CodiceArticolo', operazione: 5, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.codiceArticolo
    },
    {
      fieldName: 'VarianteArt', operazione: 5, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.varianteArt
    },
    {
      fieldName: 'CodCliente', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.codCliente
    },
    {
      fieldName: 'IdOrdVen', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.idOrdVen
    },
    {
      fieldName: 'CodTerzista', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.codTerzista
    },
    {
      fieldName: 'UdM', operazione: 5, value1: '', value2: '',
      tipoFormControl: TipoFormControl.inputText, showColumn: this.localService.showColumns.value.udM
    },
    {
      fieldName: 'QuantitaLavorata', operazione: 3, value1: '-99999', value2: '',
      tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.quantita
    },
    {
      fieldName: 'Quantita', operazione: 3, value1: '-99999', value2: '',
      tipoFormControl: TipoFormControl.inputNumber, showColumn: this.localService.showColumns.value.quantitaToDo
    },
    {
      fieldName: 'Stato', operazione: 1, value1: '', value2: '',
      tipoFormControl: TipoFormControl.select, options: [], showColumn: this.localService.showColumns.value.stato
    }
  ];

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private localService: LocalService) { }

  ngOnInit() {
    this.viewGroup = this.organizzazioniService.viewGroup;
    this.subscription = this.organizzazioniService.currentAccountSettingsSubject
      .subscribe((_accountOrg: AccountOrganizzazione) => {
        if (_accountOrg) {
          this.viewGroup = _accountOrg.activeViewGroup;
        }
      });
  }

  // Trigger di refresh mirato SOLO alla lista di questa tab (invece del broadcast globale
  // LocalService.handleRefresh, che avrebbe rilanciato anche il fetch dell'altra tab).
  onHeaderRefresh() {
    void this.listComponent?.readOrdiniInviati(false);
  }

  selectOrdineGroup = (ordineGroup: OrdineGroup) => this.ordineGroupSended.emit(ordineGroup);
  selectOrdine = (ordine: Ordine) => this.ordineSended.emit(ordine);

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
